import React from "react";
import ExpertiseSticky from "./ExpertiseSticky";
import ExpertiseText from "./ExpertiseText";
import PageHeading from "../../../templates/PageHeading";
import { useQuery } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../../utils/BaseUrl";
import PageTitleCard from "../../templates/PageTitleCard";
import ResponsiveExpertrise from "./ResponsiveExpertrise";
import FixedFooter from "../../templates/FixedFooter";
import Footer from "../../../components/footer/Footer";
import BackHome from "../../../templates/BackHome";
import SubHeadingText from "../../../common/SubHeadingText";
import RightArrow from "../../../templates/RightArrow";
import CurrentPath from "../../../templates/CurrentPath";

const Expertise = () => {
  const { data } = useQuery({
    queryKey: "getAllExpertise",
    queryFn: () =>
      axios.get(`${BASEURL}expertise`).then((res) => {
        return res?.data;
      }),
  });

  return (
    <>
      <PageTitleCard>
        <PageHeading>Expertise</PageHeading>
        <div className="flex justify-evenly items-center">
          <BackHome /> <RightArrow /> <CurrentPath>Expertise</CurrentPath>
        </div>
      </PageTitleCard>

      <div className="py-8 container mx-auto max-sm:px-8">
        <SubHeadingText>Our Expertise</SubHeadingText>

        <div className="flex w-full  md:px-4 sm:px-4 max-sm:px-4  ">
          <div className="lg:hidden md:block sm:block max-sm:block">
            <ResponsiveExpertrise data={data?.data} />
          </div>
          <div className="w-1/2 p-24 lg:block md:hidden sm:hidden max-sm:hidden ">
            <ExpertiseSticky data={data?.data} />
          </div>

          <div className="w-1/2 p-10 lg:block md:hidden sm:hidden max-sm:hidden">
            <ExpertiseText data={data?.data} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Expertise;
